import { Layout, message, Spin } from 'antd';
import { Outlet, useNavigate } from 'react-router';
import Header from '../header';
import { useTheme } from 'styled-components';
import { useEffect, useState } from 'react';
import { getUserInfo, getLicenseForCompany } from '../../utils/httpRequest';
import { useAppDispatch } from '../../store';
import { setUser, setLicenses } from '../../slices/profile';
import { fetchNotifications } from '../../slices/notifications';

const layoutStyle = {
  height: '100vh',
  overflow: 'hidden',
  backgroundColor: '#f7f7f7',
};

const headerStyle: React.CSSProperties = {
  position: 'sticky',
  padding: 0,
  backgroundColor: '#fff',
  display: 'flex',
  alignItems: 'center',
};

const contentStyle = {
  height: 'calc(100% - 64px)',
  overflow: 'auto',
};

const Content = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const dispatch = useAppDispatch();
  const [messageApi, contextHolder] = message.useMessage();

  const getData = async () => {
    try {
      setLoading(true);
      dispatch(fetchNotifications());
      const userRes = await getUserInfo();
      dispatch(setUser(userRes));
      if (userRes?.companyID) {
        const licenseRes = await getLicenseForCompany(userRes.companyID);
        dispatch(setLicenses(licenseRes));
      }
    } catch (err: any) {
      messageApi.error(err?.message || 'Get user info failed!');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
    } else {
      getData();
    }
  }, []);

  return (
    <Layout style={layoutStyle}>
      <Layout.Header style={headerStyle}>
        <Header />
      </Layout.Header>
      {/* <Layout>
        <Layout.Sider
          style={{ backgroundColor: theme.antd.colorPrimary }}
          width={160}
        >
          <SideMenu></SideMenu>
        </Layout.Sider>
        
      </Layout> */}
      <Layout>
        <Layout.Content style={contentStyle}>
          {contextHolder}
          <Outlet />
        </Layout.Content>
      </Layout>
      <Spin fullscreen spinning={loading}></Spin>
    </Layout>
  );
};

export default Content;
